export default {
  velt: {
    openPanel: 'Ouvrir le panneau des commentaires',
    closePanel: 'Fermer le panneau des commentaires',
    panel: 'Panneau des commentaires',
    tabs: 'Onglets du panneau des commentaires',
    comments: 'Commentaires',
    settings: 'Paramètres et autorisations',
    dragOrTapComment: 'Faites glisser pour ajouter un commentaire, ou appuyez pour afficher les commentaires',
    assignComment: 'Attribuer un commentaire',
    markAsUnread: 'Marquer comme non lu',
    markAsRead: 'Marquer comme lu',
    unsubscribe: 'Se désabonner',
    subscribe: 'S\'abonner',
    deleteThread: 'Supprimer le fil',
    editComment: 'Modifier le commentaire',
    emptyPlaceholder: 'Donnez un avis, posez une question ou laissez une note pour les membres de votre équipe',
    searchPlaceholder: 'Rechercher des commentaires',
    commentPlaceholder: 'Commenter {page}',
    replyPlaceholder: 'Répondre....',
    filterPages: 'Pages',
    filterAuthor: 'Auteur',
    filterTagged: 'Mentionnés',
    statusOpen: 'Ouvert',
    statusResolved: 'Résolu',
    anonymous: 'Anonyme',
    settingsPanel: {
      title: 'Qui peut commenter ?',
      everyoneLabel: 'Tout le monde',
      restrictedLabel: 'Collaborateurs invités uniquement',
      emailsLabel: 'E-mails',
      emailsPlaceholder: 'Ajoutez un e-mail et appuyez sur Entrée',
    },
  },
}
